<template>
  <section class="introduction" id="intro">
    <custom-title text="Introduction" header-class="introduction-title" text-colour="#272460" stripe-colour="#A3D9E9"></custom-title>
    <p>
      Unicorn Global is a unique <b>Shopify App Development</b> company that is committed to excellence.
    </p>
    <!-- <p> -->
      <!-- Our <b>groundbreaking approach</b> empowers you by taking care of the trickiest piece of any venture - the development. -->
      <!-- This is what we excel at and is what we focus on. -->
    <!-- </p> -->
    <p>
      Over time we have formulated a new way of working that is designed to <b>maximise throughput and productivity</b>, and
      this infuses everything we offer. We don't just develop Shopify apps, <b>we're actively improving the Shopify ecosystem.</b>
    </p>
    <p>
      We actively contribute to the broader <b>open source tools and frameworks</b> that work with Shopify, and even maintain packages used by external developers in-house.
    </p>
    <p>
      The results of our untraditional <b>Unicorn Process</b> speak for themselves, which means we're able to deliver a high level of personalised customer service.
    </p>
  </section>
</template>

<style lang="scss" scoped>
  .introduction {
    margin-top: 0.5em;
    margin-bottom: 2em;
    position: relative;
    z-index: 100;
  }

  b {
    color: #605F8C;
  }

  p {
    max-width: 80%;
    width: 600px;
    margin: 1em auto;
    color: #605F8C;
    font-size: 1.1rem;
    text-align: left;
  }
</style>

<script>
import CustomTitle from './CustomTitle'

export default {
  components: {
    CustomTitle
  }
}
</script>
